import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ApiBaseService } from "./migrate/api.base.service";
import { ToolsService } from "./migrate/tools.service";

@Injectable({ providedIn: "root" })
export class UserService {
  private service: ApiService;
  private apiBaseService: ApiBaseService;

  constructor(
    apiService: ApiService,
    apiBaseService: ApiBaseService,
    private tools: ToolsService
  ) {
    this.service = apiService;
    this.apiBaseService = apiBaseService;
  }

  async login(username: string, senha: string): Promise<any> {
    const payload = {
      cdUsuario: username,
      cdSenha: senha,
    };

    try {
      const user = await this.service.post("usuario/login", payload);

      if (!user) {
        Promise.reject(Error("Invalid user"));
      }

      return user;
    } catch (error) {
      this.tools
        .builder()
        .openToast.emit(
          error.message ? error.message : "Desculpe, ocorreu algum erro!"
        );
    }
  }

  async me(): Promise<any> {
    try {
      const user = await this.apiBaseService.get<any>({
        url: "usuarios/me",
      });

      if (!user) {
        Promise.reject(Error("Invalid user"));
      }

      return user;
    } catch (error) {
      console.error("me", error);
      return null;
    }
  }
}
